// --------------------------------------------------------------------------
// #13 - in-text hot spot
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    function init() {
        var jqHotSpot = context.find('[data-binding="hotspot"]'),
            selectedClass = 'is-selected';

        /**
        * Loop through hotspots and create tooltips
        */
        jqHotSpot.each(function () {
            var hotspotContent = $(this).data('hotspot-content'),
                jqHotspotTooltip = '<span class="open" data-ga="hotspot"></span><span class="hotspot__tooltip"><span class="close"></span>' + hotspotContent + '</span>';
            $(this).append(jqHotspotTooltip);
        });

        /**
        * Toggle hotspot tooltip
        */
        jqHotSpot.on('click', '.open', function () {
            //close other tooltips first
            context.find('.is-selected').removeClass(selectedClass);
            $(this).parent().addClass(selectedClass);
        });

        jqHotSpot.on('click', '.close', function () {
            //close other tooltips first
            $(this).parents('.hotspot').removeClass(selectedClass);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/in-text-hotspot.js
// module id = 91
// module chunks = 0